const TextField = ({label, value, onChange, type = 'text', maxLength}) => (
  <div style={{marginBottom: '10px'}}>
    <label style={{display: 'block', marginBottom: '5px'}}>{label}</label>
    <input
      type={type}
      value={value}
      maxLength={maxLength}
      onChange={onChange}
      style={{width: '100%', padding: '10px', borderRadius: '5px'}}
    />
  </div>
);

export default TextField;
